// @flow
export default (theme: Object) => ({
    container: {
        position: 'relative',
    },
    form: {
        width: '100%',
        maxWidth: 600,
    },
    autocomplete: {
        marginBottom: theme.spacing(2),
    },
    questionList: {
        marginBottom: 40,
    },
    question: {
        marginBottom: theme.spacing(1),
    },
    button: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        zIndex: 10,
    },
});
